import { render, staticRenderFns } from "./SalesTrendChart.vue?vue&type=template&id=441f435a&scoped=true&"
import script from "./SalesTrendChart.vue?vue&type=script&lang=js&"
export * from "./SalesTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesTrendChart.vue?vue&type=style&index=0&id=441f435a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f435a",
  null
  
)

export default component.exports